import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { makeRequest } from "../../api/api";

export const generateAutoPool = createAsyncThunk(
  'pooling/generateAutoPool',
  async (data) => {


    // Use the query string in the request URL
    const request = await makeRequest("post", `v2/pooling/generate_auto_pool/`,data);
    const response = request.data.data;
    return response;
  }
);

export const generateAutoPoolData = createAsyncThunk(
  'pooling/generateAutoPoolData',
  async (data) => {
    const request = await makeRequest("post", `v2/pooling/get_price_breakdown/`,data);
    const response = request.data.data;
    return response;
  }
);

export const getFinalPoolDetails = createAsyncThunk(
  'pooling/getFinalPoolDetails',
  async (data) => {
    const request = await makeRequest("post", `v2/pooling/save_auto_pool/`,data);
    const response = request.data;
    return response;
  }
);

export const notificationList = createAsyncThunk(
  'pooling/notificationList',
  async (params) => {

    const queryString = "?" + new URLSearchParams(params).toString();

    // Use the query string in the request URL
    const request = await makeRequest("get", `v2/pooling/get_notification/${queryString}`,);
    const response = request.data.data;
    return response;
  }
);

export const notificationAction = createAsyncThunk(
  'pooling/notificationAction',
  async (params) => {
    // Use the query string in the request URL
    const request = await makeRequest("patch", `v2/pooling/notification_action/`,params);
    const response = request.data.data;
    return response;
  }
);

export const AdminNotificationAction = createAsyncThunk(
  'pooling/AdminNotificationAction',
  async (params) => {
    // Use the query string in the request URL
    const request = await makeRequest("patch", `v2/pooling/is_admin_approve/`,params);
    const response = request.data.data;
    return response;
  }
);

export const poolNotificationDetails = createAsyncThunk(
  'pooling/poolNotificationDetails',
  async (params) => {

    const queryString = "?" + new URLSearchParams(params).toString();

    // Use the query string in the request URL
    const request = await makeRequest("get", `v2/pooling/get_notification_details/${queryString}`,);
    const response = request.data.data;
    return response;
  }
);

export const updatePriceBreakDown = createAsyncThunk(
  'pooling/updatePriceBreakDown',
  async (data) => {

    // Use the query string in the request URL
    const request = await makeRequest("post", `v2/pooling/return_red_breakdown/`,data);
    const response = request.data.data;
    return response;
  }
);





const autoPoolingSlice = createSlice({
  name: "autoPooling",
  initialState: {
    status: 'idle',
    initiatepoolstatus: "failed",
    AutoPoolsDataPayload: {},
    AutoPoolsData:[],
    FinalPoolDetails:[],
    NotificationListData: [],
    NotificationActionMessage: null,
    PoolDetailsData: null,
  },
  reducers: {
    updateAutoPoolsData: (state, action) => {
      state.AutoPoolsData = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(poolNotificationDetails.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(poolNotificationDetails.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.PoolDetailsData = action.payload;
      })
      .addCase(poolNotificationDetails.rejected, (state) => {
        state.status = 'failed';
      })
      .addCase(updatePriceBreakDown.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(updatePriceBreakDown.fulfilled, (state, action) => {
        state.status = 'succeeded';
        console.log("action.payload",action.payload)
        state.AutoPoolsData = state.AutoPoolsData.map(poolData => ({
          ...poolData,
          total_value: action.payload?.data.find(item => item.token_id === poolData.token_id)?.total_value || poolData.total_value
        }));
      })
      .addCase(updatePriceBreakDown.rejected, (state) => {
        state.status = 'failed';
      })
      .addCase(generateAutoPool.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(generateAutoPool.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.AutoPoolsDataPayload = action.payload;
      })
      .addCase(generateAutoPool.rejected, (state,action) => {
        state.status = 'failed';
        state.AutoPoolsDataPayload = action.payload;

      })
      .addCase(generateAutoPoolData.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(generateAutoPoolData.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.AutoPoolsData = action.payload;
      })
      .addCase(generateAutoPoolData.rejected, (state) => {
        state.status = 'failed';
      })
      .addCase(getFinalPoolDetails.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(getFinalPoolDetails.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.FinalPoolDetails = action.payload;
      })
      .addCase(getFinalPoolDetails.rejected, (state) => {
        state.status = 'failed';
      })
      .addCase(notificationList.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(notificationList.fulfilled, (state, action) => {
        state.status = 'succeeded';
        console.log("my values",action.payload)
        state.NotificationListData = action.payload;
      })
      .addCase(notificationList.rejected, (state) => {
        state.status = 'failed';
      })
      .addCase(notificationAction.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(notificationAction.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.NotificationActionMessage = action.payload;
      })
      .addCase(notificationAction.rejected, (state) => {
        state.status = 'failed';
      })
      .addCase(AdminNotificationAction.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(AdminNotificationAction.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.NotificationActionMessage = action.payload;
      })
      .addCase(AdminNotificationAction.rejected, (state) => {
        state.status = 'failed';
      });    
      
  },
})

export const { updateAutoPoolsData } = autoPoolingSlice.actions;

export default autoPoolingSlice.reducer;